import { sessionService } from '../../application/SessionService';

interface UseAsUserResponse {
  asUser?: string;
  token?: string;
  beAsUser: ({ id }: { id: string }) => void;
  deleteAsUser: () => void;
}

export const useAsUser = (): UseAsUserResponse => {
  return {
    asUser: sessionService.getAsUser() !== `` ? sessionService.getAsUser() : undefined,
    token: sessionService.getToken(),
    beAsUser: ({ id }: { id: string }) => sessionService.beAsUser(id),
    deleteAsUser: () => sessionService.deleteAsUser(),
  };
};
